import type { GaApp } from '~/modules/app'

import { ApiService } from './api.service'
import { MainService } from './main.service'
import { MenuService } from './menu.service'
import { ModalService } from './modal.service'
import { ModalQueueService } from './modal-queue.service'
import { PageService } from './page.service'
import { PrizesService } from './prizes.service'
import { RatingService } from './rating.service'
import { SourcesService } from './sources.service'
import { UserService } from './user.service'

export const services = (gaApp: GaApp) => ({
  main: new MainService(gaApp),
  user: new UserService(gaApp),
  api: new ApiService(gaApp),
  page: new PageService(gaApp),
  prizes: new PrizesService(gaApp),
  rating: new RatingService(gaApp),
  menu: new MenuService(gaApp),
  sources: new SourcesService(gaApp),
  modal: new ModalService(gaApp),
  modalQueue: new ModalQueueService(gaApp),
})
